import type { ReactNode } from 'react';

export function AttributeTable<T extends { valueKind: 'flat' | 'percent' }>({ groups, children }: {
  groups: [string, T[]][]; children(item: T): ReactNode;
}) {
  return <>{groups.map(([group, items]) => <section className="game-attribute-group" key={group}>
    <h3>{group}</h3><div className="game-attribute-grid">
      {(['flat', 'percent'] as const).map(kind => {
        const values = items.filter(item => item.valueKind === kind);
        const label = kind === 'flat' ? '数值' : '百分比';
        return <section className="game-attribute-kind" aria-label={`${group}${label}`} key={kind}>
          <header><span>{label}</span><small>{values.length} 项</small></header>
          <div>{values.map(children)}{!values.length && <span className="game-attribute-empty">—</span>}</div>
        </section>;
      })}
    </div>
  </section>)}</>;
}
